export const AUTH_STORAGE_KEY = 'ReactStorage__Authentication';
